import { AppEntity, ContactPersonId } from '@app/icare/db/schema/common'
import { PharmacyId } from '@app/icare/entities/pharmacy/schema/Pharmacy'
import { TherapyTypeEnum } from '@app/icare/entities/therapy/schema/TherapyType'
import { entityId } from '@pkg/db/schema'
import { z } from 'zod'
import { PatientRelation } from './PatientRelation'

export const PatientPharmacyId = entityId('patientPharmacy')

export type PatientPharmacyIdType = typeof PatientPharmacyId.Type

export const PatientPharmacyRelationSchema = PatientRelation.extend({
  id: PatientPharmacyId.schema,
  toId: PharmacyId.ref,
  prescriber: z
    .object({
      therapies: z.array(z.enum(TherapyTypeEnum.$.zodEnum())).nullish(),
    })
    .nullish(),
})
export type PatientPharmacyRelation = z.infer<typeof PatientPharmacyRelationSchema>

export const PatientPharmacyContactPersonId = entityId('patientPharmacyContactPerson')

export const PatientPharmacyContactPersonSchema = AppEntity.extend({
  id: PatientPharmacyContactPersonId.schema,
  ownerId: PatientPharmacyId.ref,
  contactPersonId: ContactPersonId.ref,
})

export type PatientPharmacyContactPerson = z.infer<typeof PatientPharmacyContactPersonSchema>
